import type { ReactNode, FC } from 'react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import AdoptableShopCard from '@wix/da-shared-react/pkg/ShopCard/AdoptableShopCard';
import { AllowedIndicators } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/legos/DeviationThumbIndicators';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ShopItemType } from '../../../../../types/shop';
import { RenderCardProps } from '../_partials/ShopGridWithFilters/types';
import ShopGridWithFilters from '../_partials/ShopGridWithFilters';
import AdoptablesEmptyState from '../_partials/AdoptablesEmptyState';
import OriginalsPromoBanner from '../_partials/OriginalsPromoBanner';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';

const BILOGGER_CONTEXT = {
  sectionname: 'Adoptables',
  widgetname: 'adoptables',
};

const renderCard = (props: RenderCardProps): ReactNode => {
  const { subject, index, width, style } = props;
  return (
    <div style={{ ...style, height: 'auto' }}>
      <AdoptableShopCard
        key={index}
        width={width}
        withAuthorDetails={false}
        allowedIndicators={AllowedIndicators.Discount}
        withOwnerDetails
        deviation={subject as PapiDeviation}
      />
    </div>
  );
};

export interface Props {
  className?: string;
}

export const ShopAdoptables: FC<Props> = ({ className }) => {
  const customExclusives = useFlag('custom_exclusives');
  const isOwner = useSelector(isCurrentUserProfileOwner);
  const isMobile = useContext(MobileContext);

  // Show originals promo banner for non-owners when custom_exclusives is enabled
  // Desktop: after 2 rows (index 1), Mobile: after 3 rows (index 2)
  const showOriginalsPromo = customExclusives && !isOwner;
  const contentAfterRowIndex = isMobile ? 2 : 1;

  return (
    <BiLoggerContextProvider value={BILOGGER_CONTEXT}>
      <ShopGridWithFilters
        className={className}
        itemType={ShopItemType.ADOPTABLES}
        moduleName="adoptables"
        uploadMoreBiClickInfo="create_adoptable"
        invitationToUpload={AdoptablesEmptyState}
        renderCard={renderCard}
        contentAfterRow={showOriginalsPromo ? <OriginalsPromoBanner /> : undefined}
        contentAfterRowIndex={contentAfterRowIndex}
      />
    </BiLoggerContextProvider>
  );
};

ShopAdoptables.displayName = 'ShopAdoptables';
export default ShopAdoptables;
